import { solvePow as e } from "@akedly/shield";
//#region src/passkeys/native/shieldPow.ts
var t = async (t, n) => {
	let { nonce: r } = await e(t, n, { useWorker: !1 });
	return r;
};
//#endregion
export { t as solvePowNative };
